import createAxiosInstance from "../services/axiosInstance";
import {
  ICreateVectorizationPresetsRequest,
  ICreatInputImageUploadResponseModel,
  IVectorizationDataModel,
  IVectorizedFeedbackModelRequest,
} from "../types/vectorization";
import {Auth} from "aws-amplify";

export const getAllVectorizationImages = async (
    pageSize: number = 20,
    createdBy: string,
    isSeeAll: boolean
): Promise<IVectorizationDataModel[]> => {
  const currentSession = await Auth.currentSession();
  const currentUserEmail = String(currentSession.getIdToken().payload["email"]);

  let createdByQuery = "";
  if (!isSeeAll) {
    if (createdBy.length > 0) {
      createdByQuery = `&created_by=${createdBy.toLowerCase()}`;
    }
    if (createdBy.length === 0) {
      createdByQuery = `&created_by=${currentUserEmail.toLowerCase()}`;
    }
  }
  const api = await createAxiosInstance();
  try {
    const response = await api.get(`?page_size=${pageSize}${createdByQuery}`);
    return response.data["items"];
  } catch (error) {
    throw error;
  }
};


export const restartVectorization = async (
    vectorizationId: string,
    key: string,
    file_name: string
): Promise<IVectorizationDataModel> => {
  const api = await createAxiosInstance();
  try {
    const response = await api.post(`/${vectorizationId}`, {
      input_file_key: key,
      file_name: file_name,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Start vectorization apis
export const createInputImageUploadUrl =
    async (): Promise<ICreatInputImageUploadResponseModel> => {
      const api = await createAxiosInstance();
      try {
        const response = await api.post(`/images/input-url`, {
          image_md5_checksum: null,
        });
        return response.data;
      } catch (error) {
        throw error;
      }
    };

export const createVectorizationPresets = async (
    requestData: ICreateVectorizationPresetsRequest
): Promise<IVectorizationDataModel[]> => {
  const api = await createAxiosInstance();
  try {
    const response = await api.post("/presets", requestData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitFeedback = async (
    requestData: IVectorizedFeedbackModelRequest
): Promise<string> => {
  const api = await createAxiosInstance();
  try {
    const response = await api.post("/feedback/save", {
      vectorization_id: requestData.id,
      feedback_rating: requestData.feedbackRating,
      feedback_text: requestData.feedbackText
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
